import React, { Fragment } from 'react'

import './styles.scss'

import intro55desktop_topleft from './img/intro55desktop-topleft@2x.png'
import intro55mobile_bottomleft from './img/intro55mobile-bottomleft@2x.png'
import intro55desktop_bottomright from './img/intro55desktop-bottomright@2x.png'
import intro55mobile from './img/intro55mobile-@2x.png'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { coupleSimplifiedName, weddingDate },
  buttonMessage,
  warningMessage,
  locale = 'pt-BR',
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  const returnWeddingDate = new Intl.DateTimeFormat(locale)
    .format(new Date(weddingDate.timestamp))
    .replace(/\//g, '.')

  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro55">
      <div className="bp1-intro55desktop">
        <div className="bp1-mainbackground">
          {background && <img src={background} className="bp1-abackground" />}
        </div>
        <div className="bp1-mask"></div>
        <div className="bp1-button-layout-container">
          <div className="bp1-button">
            <div
              className="bp1-sitedecasamentoe"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <button className="bp1-button1" onClick={onSkipIntro}>
              <div className="bp1-button2"></div>
              <div className="bp1-pularintrodu347343o">{buttonMessage}</div>
            </button>
          </div>
        </div>
        <div className="bp1-main-layout-container">
          <div className="bp1-main">
            <div className="bp1-ornaments bp1-intro55-anima-animate-enter">
              <img src={intro55desktop_topleft} className="bp1-topleft" />
              <img src={intro55mobile_bottomleft} className="bp1-topright" />
              <img src={intro55mobile_bottomleft} className="bp1-bottomleft" />
              <img
                src={intro55desktop_bottomright}
                className="bp1-bottomright"
              />
            </div>
            <div className="bp1-couplename">
              <div
                className="notranslate bp1-couplesimplifiednamebride bp1-intro55-anima-animate-enter2"
                style={{
                  fontSize: !coupleSimplifiedName.groom ? '104px' : undefined,
                }}
              >
                {coupleSimplifiedName.bride}
              </div>
              {!!coupleSimplifiedName.groom && (
                <Fragment>
                  <img
                    src={intro55mobile}
                    className="bp1-image1 bp1-intro55-anima-animate-enter1"
                  />
                  <div className="notranslate bp1-couplesimplifiednamegroom bp1-intro55-anima-animate-enter3">
                    {coupleSimplifiedName.groom}
                  </div>
                </Fragment>
              )}
            </div>
            <div className="bp1-daymonthsimplifi bp1-intro55-anima-animate-enter4">
              {returnWeddingDate}
            </div>
          </div>
        </div>
      </div>
      <div className="bp2-intro55mobile">
        <div className="bp2-mainbackground">
          {background && <img src={background} className="bp1-abackground" />}
        </div>
        <div className="bp2-mask"></div>
        <div className="bp2-button-layout-container">
          <div className="bp2-button">
            <div
              className="bp2-sitedecasamentoe"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <button className="bp2-button1" onClick={onSkipIntro}>
              <div className="bp2-button2"></div>
              <div className="bp2-pularintrodu347343o">{buttonMessage}</div>
            </button>
          </div>
        </div>
        <div className="bp2-monogram-layout-container">
          <div className="bp2-monogram">
            <div className="bp2-ornaments bp2-intro55-anima-animate-enter">
              <img src={intro55desktop_topleft} className="bp2-topleft" />
              <img src={intro55mobile_bottomleft} className="bp2-topright" />
              <img src={intro55mobile_bottomleft} className="bp2-bottomleft" />
              <img
                src={intro55desktop_bottomright}
                className="bp2-bottomright"
              />
            </div>
            <div className="bp2-couplename">
              <div
                className="notranslate bp2-couplesimplifiednamebride bp2-intro55-anima-animate-enter2"
                style={{
                  fontSize: !coupleSimplifiedName.groom ? '104px' : undefined,
                }}
              >
                {coupleSimplifiedName.bride}
              </div>
              {!!coupleSimplifiedName.groom && (
                <Fragment>
                  <img
                    src={intro55mobile}
                    className="bp2-image1 bp2-intro55-anima-animate-enter1"
                  />
                  <div className="notranslate bp2-couplesimplifiednamegroom bp2-intro55-anima-animate-enter3">
                    {coupleSimplifiedName.groom}
                  </div>
                </Fragment>
              )}
            </div>
            <div className="bp2-daymonthsimplifi bp2-intro55-anima-animate-enter4">
              {returnWeddingDate}
            </div>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
